import React from 'react';
import banner from '../../assets/images/banner.png';
import { Typewriter } from 'react-simple-typewriter';

const Banner = () => {
    return (
        <header id="home" className="bg-secondary">
            <div className="px-4 lg:px-60 md:px-32">
                <div className="flex lg:flex-row-reverse items-center justify-between min-h-screen lg:flex-nowrap flex-wrap ">
                    <div>
                        <img
                            data-aos="fade-left"
                            data-aos-duration="2000"
                            src={banner}
                            className="sm:max-w-sm"
                            alt="palakxdev"
                        />
                    </div>
                    <div data-aos="fade-right" data-aos-duration="2000">
                        <div>
                            <h1 className="text-4xl lg:text-5xl font-bold leading-snug">
                                Hey, I'm{' '}
                                <span className="text-accent leading-snug">
                                    Palak Sarker
                                </span>
                            </h1>
                            <h3 className="text-xl lg:text-3xl mt-5 leading-normal">
                                I'm a{' '}
                                <span className="text-accent">
                                    <Typewriter
                                        words={[
                                            'Web Developer',
                                            'React Developer',
                                            'Programmer',
                                        ]}
                                        loop="false"
                                        cursor
                                        typeSpeed={100}
                                        deleteSpeed={80}
                                    />
                                </span>
                            </h3>
                            <p className="py-6 lg:w-3/4 ">
                                I'm passionate about creating dynamic and
                                visually appealing websites. And aspiring to be
                                a full-stack developer (MERN).
                            </p>

                            <a
                                href="https://drive.google.com/file/d/19mwYqoIahmWMXnZ-C58Z3mpyRH0kRWBg/view?usp=sharing"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <button className="btn btn-accent text-white rounded-sm">
                                    My Resume
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Banner;
